import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Grid, Typography, Stack, debounce, Button, Dialog, DialogContent, DialogTitle, DialogActions, Rating } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/EditOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import BottomButtonsforWorkOrder from "./BottomButtonsforWorkOrder";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import { useDispatch, useSelector } from "react-redux";
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import { getAuthToken, getCreatedBy, getFacilityId } from "../../utility/tokenUtility";
import { updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import { useLocation } from "react-router-dom";
import { mandatoryFields } from "../../redux/actions/assetActions";
import PageLoader from "../commoncomponents/PageLoader";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import CustomTimePicker from "../commoncomponents/CustomTimePicker";
import CustomDialog from "../commoncomponents/CustomDialog";
import SignatureGrid from "./SignatureGrid";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import axios from "axios";
import { format, formatDate, isValid, min, parseISO } from "date-fns";
import CustomTooltip from "../commoncomponents/CustomTooltip";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { processingPercentageValue, statusList } from "../../utility/message";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import dayjs from "dayjs";

const CompletionInfo = ({ setPage, page, buttonAttributes }) => {
  const findHeaderContent = buttonAttributes.find(
    (item) => item.currentPageName === page
  );

  const dispatch = useDispatch();
  const location = useLocation();
  const basicDetails = useSelector((state) => state.workOrderBasicDetails);
  const completionInfoMandatoryFields = useSelector(
    (state) => state.workOrdermandatoryFields.completionInfoMandatoryFields
  );
  const status = useSelector((state) => state?.workOrderStatus?.status);
  const assetCategoryType = useSelector((state) => state?.serviceType);
  const viewmode = location.state?.viewmode;
  const completionInfo = basicDetails?.completionInfo || {};
  const costInfo = basicDetails?.completionInfo?.costInfo || {};
  const respondedBy = basicDetails?.assessments?.respondedBy?.label || "";
  const designation = basicDetails?.assessments?.designation || "";
  const setOutsourceDetails = basicDetails?.vendorField;
  const getRespondStartDateandTime =
    basicDetails?.assessments?.respondedStartDateandTime || "";
  const getRespondEndDateandTime =
    basicDetails?.assessments?.respondedEndDateandTime || "";
  const repairTrackerTimes = basicDetails?.assessments?.repairTracker || [];
  const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
  const categoryType = assetCategoryType?.category;
  const categoryFieldName = assetCategoryType?.category === "Scheduled" ? "scheduled" : "unscheduled";
  const setScheduledField = categoryType === "Scheduled" ? true : false;
  const token = getAuthToken("id_token");
  const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
  const workorderDateTime = basicDetails?.workorderDateandTime || "";


  const [completionInfoData, setCompletionInfoData] = useState(
    completionInfo || {}
  );
  const [loading, setLoading] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorDialogMssg, setErrorDialogMssg] = useState("");
  const [option, setOption] = useState({
    respondedBy: [],
  });
  const [error, setError] = useState({
    respondedDateandTime: false,
    completionBy: false,
    actionTaken: false,
  });
  const [errorMessage, setErrorMessage] = useState({
    respondedDateandTime: "",
    completionBy: "",
    actionTaken: "",
  });

  const [signatureRows, setSignatureRows] = useState([
    {
      id: 1,
      category: '',
      fileType: '',
      designation: '',
      size: '',
    }
  ]);
  const [signatureDeleteDialog, setSignatureDeleteDialog] = useState(false);
  const [signatureEditDialog, setSignatureEditDialog] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    date: null
  });
  const [signatureId, setSignatureId] = useState(null);
  const [signatureDialog, setsignatureDialog] = useState(false);
  const [getByIdSignatures, setGetByIdSignatures] = useState([]);
  const [isSignatureAffected, setIsSignatureAffected] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [signatureMandatory, setSignatureMandatory] = useState(false);
  const currentDate = dayjs().format('DD/MM/YYYY');



  const statusMapping = {
    "Open": 1,
    "In Progress": 3,
    "Completed": 4,
    "Closed": 5,
    "Cancelled": 6,
    "Verified": 8,
    "Not Done and Closed": 7,
    "Completed-Outsource": 9,
    "Inprogress-Outsource": 10
  };

  // Map the current status to the corresponding number
  const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value

  function AddRowButton(props) {
    const handleClick = () => {
      props.onClick();
    };

    return (

      <Box sx={{ mb: 1 }}>

        <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleClick} >
          Add Row
        </Button>
      </Box>
    );
  };

  let getFirstIndexofStartDateTime;
  let getLastIndexofEndDateTime;

  if (repairTrackerTimes.length === 1) {
    getFirstIndexofStartDateTime = repairTrackerTimes[0]?.startDateandTime || "";
    getLastIndexofEndDateTime = repairTrackerTimes[0]?.endDateandTime || "";
  } else if (repairTrackerTimes.length > 1) {
    //logic to get the earliest start date time from repair tracker times
    // getFirstIndexofStartDateTime = repairTrackerTimes.reduce((earliest, current) => {
    //   return new Date(earliest.startDateandTime) < new Date(current.startDateandTime) ? earliest : current;
    // }).startDateandTime || "";

    //logic to get the latest start date time from repair tracker times
    // getFirstIndexofStartDateTime = repairTrackerTimes.reduce((latest, current) => {
    //   return new Date(latest.startDateandTime) > new Date(current.startDateandTime) ? latest : current;
    // }).startDateandTime || "";
    getFirstIndexofStartDateTime =
      repairTrackerTimes.length > 0
        ? repairTrackerTimes[repairTrackerTimes.length - 1].startDateandTime
        : "";
    // Find the row with the greatest endDateandTime
    // getLastIndexofEndDateTime = repairTrackerTimes.reduce((latest, current) => {
    //   return new Date(latest.endDateandTime) > new Date(current.endDateandTime) ? latest : current;
    // }).endDateandTime || "";
    getLastIndexofEndDateTime =
      repairTrackerTimes.length > 0
        ? repairTrackerTimes[repairTrackerTimes.length - 1].endDateandTime
        : "";

    getLastIndexofEndDateTime = getLastIndexofEndDateTime || "";
    getFirstIndexofStartDateTime = getFirstIndexofStartDateTime || "";
  };


  // // Calculate the total Downtime in minutes from RepairTracker Rows
  // const totalMinutes = repairTrackerTimes?.reduce((prev, current) => {
  //   const duration = current?.repairDuration?.split(" "); // Split by space to handle "120 Mins"
  //   const minutes = parseInt(duration[0]) || 0; // Extract the numeric part
  //   return prev + minutes; // Add the minutes directly
  // }, 0);
  // const downTimeHrs = `${totalMinutes} Mins` || "0 Mins";

  //To calculate Downtime HRS,get the lastinderx of repairtracker end date time and workorder date time.
  let downTimeHrs = "0 Mins";
  let schdwonTimeHrs = "0 Mins";

  // Convert to Date objects
  const workorderDate = new Date(workorderDateTime);
  const getEndDateTime = new Date(getLastIndexofEndDateTime);
  const getStartDateTime = new Date(getFirstIndexofStartDateTime);

  if (!isNaN(workorderDate.getTime()) && !isNaN(getEndDateTime.getTime() && !isNaN(getStartDateTime.getTime()))) {
    // Calculate duration only if both dates are valid
    const timeDifference = Math.abs(getEndDateTime - workorderDate);
    const scheduleDifference = Math.abs(getEndDateTime - getStartDateTime);
    const scheduletotalMinutes = Math.floor(scheduleDifference / (1000 * 60)); // Convert milliseconds to minutes
    const totalMinutes = Math.floor(timeDifference / (1000 * 60)); // Convert milliseconds to minutes

    downTimeHrs = `${totalMinutes} Mins`;
    schdwonTimeHrs = `${scheduletotalMinutes} Mins`;

  };

  // Calculate the difference for Response Duration Field in minutes
  const startDate = new Date(getRespondStartDateandTime);
  const endDate = new Date(getRespondEndDateandTime);

  let responseDuration = "0 Mins"; // Default duration

  if (!isNaN(startDate) && !isNaN(endDate)) {
    // Calculate duration only if both dates are valid
    const timeDifference = Math.abs(endDate - startDate);
    const totalMinutes = Math.floor(timeDifference / (1000 * 60)); // Convert milliseconds to total minutes

    responseDuration = `${totalMinutes} Mins`;
  } else {
    responseDuration = "0 Mins";
  }

  const memoizedDetails = useMemo(
    () => ({
      respondedDateandTime: completionInfoData?.respondedDateandTime || "",
      completionBy: completionInfoData?.completionBy || "",
      actionTaken: completionInfoData?.actionTaken || "",
    }),
    [
      completionInfoData?.respondedDateandTime,
      completionInfoData?.completionBy,
      completionInfoData?.actionTaken,
    ]
  );

  const handleDateChange = (newDate) => {
    // Update the date in the form data state
    setFormData(prevState => ({
      ...prevState,
      date: newDate
    }));
  };
  const repairTrackerRows = basicDetails?.assessments?.repairTracker?.length > 0 ? true : false;




  //function to check the mandatory field are filled or not(responsible for green ticks on left side)
  const checkMandatoryValueFilled = useCallback(
    debounce((respondedDateandTime, completionBy, actionTaken) => {
      const updateStatus = (type, value, name, isVisible, errorState) => ({
        type,
        valueFilled: !errorState && !!value,
        name,
        isVisible,
      });
      const updateResponseDateandTime = updateStatus(
        "Response Date & Time",
        respondedDateandTime,
        "respondedDateandTime",
        !setScheduledField,
        error?.respondedDateandTime
      );
      const updateCompletionBy = updateStatus(
        "Completion By",
        completionBy,
        "completionBy",
        !setOutsourceDetails,
        error?.completionBy
      );
      const updateActionTaken = updateStatus(
        "Action Taken",
        actionTaken,
        "actionTaken",
        true,
        error?.actionTaken
      );
      const arrayAfterUpdating = [updateActionTaken];

      if (!setScheduledField) {
        arrayAfterUpdating.push(updateResponseDateandTime);
      }

      if (!setOutsourceDetails) {
        arrayAfterUpdating.push(updateCompletionBy)
      }

      if (
        arrayAfterUpdating !== undefined &&
        arrayAfterUpdating.every((item) => item !== undefined)
      ) {
        dispatch({
          type: "UPDATE_COMPLETION_INFO_MANDATORY_FIELDS",
          payload: arrayAfterUpdating,
        });
      }
    }),
    [dispatch, error, setOutsourceDetails]
  );

  useEffect(() => {
    const { respondedDateandTime, completionBy, actionTaken } = memoizedDetails;
    checkMandatoryValueFilled(
      respondedDateandTime,
      completionBy?.id || "",
      actionTaken?.trim()
    );
  }, [memoizedDetails, checkMandatoryValueFilled]);


  const handleValidationForRequiredFields = () => {
    let isValid = true;
    let hasError = false;

    // Check required fields
    completionInfoMandatoryFields.forEach((item) => {
      if (item.valueFilled === false) {
        setError((prev) => ({
          ...prev,
          [item.name]: true,
        }));
        setErrorMessage((prev) => ({
          ...prev,
          [item.name]: `${item.type} is required `,
        }));
        isValid = false;
      }
    });

    // Check if signatureRows length is greater than 1 and there are meaningful rows
    const gridRows = signatureRows?.filter(row => row?.designation || row?.fileType || row?.size);
    if (gridRows?.length < 1) {
      hasError = true;
      setSignatureMandatory(true);
      isValid = false;
    }

    const allErrorStateFalse = Object.values(error).every(val => val === false);
    const repairTrackerRows = basicDetails?.assessments?.repairTracker;


    // const missingEndDateTime = repairTrackerRows?.every(
    //   row => row.endDateandTime && row.endDateandTime.trim() !== ""
    // );

    const allEndDatesPresent = repairTrackerRows?.every(
      row => row.endDateandTime != null && row.endDateandTime.toString().trim() !== "" && row.startDateandTime != null && row.startDateandTime.toString().trim() !== ""
    ) ?? false;

    // const allEndDatesPresent = repairTrackerRows?.every(row => !!row.endDateandTime) ?? false;


    // const isRepairTrackValid = !!missingEndDateTime;
    const isRepairTrackValid = allEndDatesPresent;
    const isAfterImageValid = !!basicDetails.isAfterImageAttachmentUploaded;

    const shouldValidateUnscheduled = categoryType === "Unscheduled" && (!isRepairTrackValid || !isAfterImageValid);
    //const shouldValidateScheduled = categoryType === "Scheduled" && !isRepairTrackValid;

    // if (shouldValidateUnscheduled ) {
    //   isValid = false;
    //   setErrorDialog(true);
    //   const repairTrackMessage = isRepairTrackValid ? (
    //     <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
    //       <CheckCircleOutlineIcon color="success" sx={{ fontSize: 16, marginRight: "5px" }} />
    //       Repair Track Entered by Technician/Vendor.
    //     </div>
    //   ) : (
    //     <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
    //       <HighlightOffRoundedIcon color="disabled" sx={{ fontSize: 16, marginRight: "5px" }} />
    //       Repair Track start Date Time / End Date Time not entered by Technician/Vendor. Work Order cannot be completed.
    //     </div>
    //   );

    //   const afterImageMessage = categoryType === "Unscheduled" ? (
    //     isAfterImageValid ? (
    //       <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
    //         <CheckCircleOutlineIcon color="success" sx={{ fontSize: 16, marginRight: "5px" }} />
    //         After Image Uploaded.
    //       </div>
    //     ) : (
    //       <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
    //         <HighlightOffRoundedIcon color="disabled" sx={{ fontSize: 16, marginRight: "5px" }} />
    //         Please Upload the After Image.
    //       </div>
    //     )
    //   ) : null;

    //   setErrorDialogMssg(
    //     <>
    //       {repairTrackMessage}
    //       {afterImageMessage}
    //     </>
    //   );
    // }



    return isValid && !hasError;
  };

  const handleOnchange = (value, name, errorStateName) => {
    if (name === "actionTaken") {
      if (value?.startsWith(" ")) {
        setError((prev) => ({
          ...prev,
          [name]: true,
        }));
        setErrorMessage((prev) => ({
          ...prev,
          [name]: `${errorStateName} should not start with spaces`,
        }));
        return;
      } else if (value?.endsWith("  ")) {
        setError((prev) => ({
          ...prev,
          [name]: true,
        }));
        setErrorMessage((prev) => ({
          ...prev,
          [name]: `${errorStateName} should not end with spaces`,
        }));
        return;
      } else {
        setError((prev) => ({
          ...prev,
          [name]: false,
        }));
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }

    setCompletionInfoData((previous) => {
      const updatedData = {
        ...previous,
        [name]: value,
      };

      if (name === "respondedBy") {
        if (value?.id) {
          updatedData.respondedBy = { ...value, label: value?.employeename };
          updatedData.designation = value?.designation;
        } else {
          updatedData.respondedBy = "";
          updatedData.designation = "";
        }
      }

      if (name === "completionBy") {
        if (value?.id) {
          updatedData.completionBy = { ...value, label: value?.employeename };
        } else {
          updatedData.completionBy = "";
        }
      }

      return updatedData;
    });

    setError((prev) => {
      const updatedError = {
        ...prev,
        [name]: false,
      };
      return updatedError;
    });

    setErrorMessage((prev) => ({
      ...prev,
      [name]: "",
    }));
  };


  const getEmployeeDetail = async () => {
    try {
      // Attempt to fetch employee details
      const respondedBy = await workOrderSummaryRepositry.fetchEmployeeDetails();

      // Update the state with the fetched employee details
      setOption((previous) => ({
        ...previous,
        respondedBy: respondedBy?.map((item, index) => ({
          key: `option${index}`,
          label: `${item?.employeecode || ""} - ${item?.employeename || ""}` || "",
          employeename: item?.employeename || "",
          designation: item?.designation || "",
          empservice: item?.empservice || "",
          id: item?.id,
        })),
      }));
    } catch (error) {
      // Handle any errors that occur during the fetch operation
      console.error("Failed to fetch employee details:", error);
    }
  };

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      await getEmployeeDetail();
      setLoading(false);
    };
    

    setCompletionInfoData((prev) => ({
      ...prev,
      startDateandTime: getFirstIndexofStartDateTime ||  basicDetails?.completionInfo?.startDateandTime || "",
      endDateandTime: getLastIndexofEndDateTime || basicDetails?.completionInfo?.endDateandTime || "",
      respondedDateandTime: getRespondStartDateandTime,
      downTimeHours: assetCategoryType?.category === "Scheduled" ? schdwonTimeHrs || "" : downTimeHrs || "",
      duration: responseDuration,
      respondedBy: respondedBy,
      designation: designation,
    }));

    if (setOutsourceDetails) {
      setCompletionInfoData((prev) => ({
        ...prev,
        completionBy: { id: basicDetails?.assessments?.vendor?.id || "", label: basicDetails?.assessments?.vendor?.label || "" }
      }))
    };

    fetchOptions();
  }, []);  

  const handleSubmit = async (event) => {
    event.preventDefault();
    const isValid = handleValidationForRequiredFields();
    const acceptedById = basicDetails?.assessments?.respondedBy?.id || "";
    const API_Payload = {
      completedbyempid: completionInfoData?.completionBy?.id || "",
      startdate: completionInfoData?.startDateandTime || "",
      enddate: completionInfoData?.endDateandTime || "",
      acceptedbyid: completionInfoData?.respondedBy?.id || acceptedById || "",
      isassetreqnotavail: completionInfoData?.isassetreqnotavail || false,
      actiontaken: completionInfoData?.actionTaken || "",
      downtimehours: completionInfoData?.downTimeHours || "",
      sparepartscost: costInfo?.totalSparePartCost || "",
      ppmcost: costInfo?.ppmCostByPurchaseOrder || "",
      ppmcostpurorderno: costInfo?.ppmCostByPurchaseOrder || "",
      contractppmcost: costInfo?.ppmCostByContract || "",
      contractrefno: costInfo?.contractReferenceNumber || "",
      breakdowncost: costInfo?.breakDownCost || "",
      breakdowncostpurorderno: costInfo?.poNumber || "",
      totalwocost: costInfo?.totalWorkorderCost || "",
      [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
      id: completionInfoData?.id || "",
      rootcause: completionInfoData?.rootCause || "",
      timestamp: completionInfoData?.timeStamp || "",
      authorizedbyid: basicDetails?.Closedid || completionInfoData?.costInfo?.Authorizedbyid || "",
      authorizeddate: basicDetails?.Closeddate || completionInfoData?.costInfo?.Authorizeddate || "",
      tokens: token,
    };


    if (!viewmode && isValid) {

      setLoading(true);

      if (basicDetails?.completionInfo?.id) {
        const updCompletionInfo =

          await workOrderSummaryRepositry.updateCompletionInfo(
            serviceType,
            completionInfoData?.id,
            API_Payload,
            categoryType
          );
        if (updCompletionInfo?.id) {
          dispatch({
            type: "CREATE_COMPLETIONINFO",
            payload: {
              ...completionInfoData,
              id: updCompletionInfo?.id,
              timeStamp: updCompletionInfo?.timestamp,
            },
          });

          if (processingPercentage !== 100 && mappedStatus !== 5 && mappedStatus !== 8) {
            let status = basicDetails?.assessments?.repairType === "Outsource" ? statusList?.completedOutsource?.label : statusList?.completed?.label // Default to Completed

            // Iterate through each row in signatureRows
            for (const row of signatureRows) {
              if (row.designation === "End-User") {
                status = "Verified"; // Update status if any row matches the condition
                break; // Exit the loop early since the condition is satisfied
              }
            }

            // Dispatch the updated work order status
            dispatch(
              updateWorkOrderStatus("STATUS_CHANGES", {
                status,
                percentage: processingPercentage > 90 ? processingPercentage : processingPercentageValue?.completionInfo,
              })
            );
            const statusId = status === statusList?.completed?.label ? statusList?.completed?.id :
              status === statusList?.completedOutsource?.label ? statusList?.completedOutsource?.id :
                status === statusList?.verified?.label ? statusList?.verified?.id :
                  "";

            await workOrderSummaryRepositry.workorderPushNotificationStatus(
              serviceType,
              basicDetails?.id,
              statusId,
              processingPercentage > processingPercentageValue?.costInfo ? processingPercentage : processingPercentageValue?.completionInfo,
              basicDetails?.category?.id
            );
          };
          setPage("Cost Info");
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        }
        else if (updCompletionInfo?.response?.data?.status === 400) {
          setErrorDialog(true);
          setErrorDialogMssg(`${updCompletionInfo?.response?.data?.detail}`)
        }
        else if (updCompletionInfo?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg(
            "An unexpected error occurred while processing your request."
          );
        }
      } else {
        const saveCompletionInfo =
          await workOrderSummaryRepositry.addCompletionInfo(
            serviceType,
            API_Payload,
            categoryType
          );

        await workOrderSummaryRepositry.updateCompletionInfonotification(
          serviceType,
          basicDetails?.id,
          getFacilityId(),
          categoryType
        );

        if (saveCompletionInfo?.id) {
          dispatch({
            type: "CREATE_COMPLETIONINFO",
            payload: {
              ...completionInfoData,
              id: saveCompletionInfo?.id,
              timeStamp: saveCompletionInfo?.timestamp || "",
            },
          });
          let status = basicDetails?.assessments?.repairType === "Outsource" ? statusList?.completedOutsource?.label : statusList?.completed?.label //To get the status ID ; // Default to Completed

          // Iterate through each row in signatureRows
          for (const row of signatureRows) {
            if (row.designation === "End-User") {
              status = "Verified"; // Update status if any row matches the condition
              break; // Exit the loop early since the condition is satisfied
            }
          }

          // Dispatch the updated work order status
          dispatch(
            updateWorkOrderStatus("STATUS_CHANGES", {
              status,
              percentage: processingPercentageValue?.completionInfo,
            }));

          const statusId = status === statusList?.completed?.label ? statusList?.completed?.id : statusList?.completedOutsource?.label ? statusList?.completedOutsource?.id : statusList?.verified?.label ? statusList?.verified?.id : "" //To get the status ID 

          await workOrderSummaryRepositry.workorderPushNotificationStatus(
            serviceType,
            basicDetails?.id,
            statusId,
            processingPercentageValue?.completionInfo,
            basicDetails?.category?.id
          );
          setPage("Cost Info");
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        } else if (saveCompletionInfo?.response?.data?.status === 400) {
          setErrorDialog(true);
          setErrorDialogMssg(`${saveCompletionInfo?.response?.data?.detail}`)
        }
        else if (saveCompletionInfo?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg(
            "An unexpected error occurred while processing your request."
          );
        }
      }
    } else if (!viewmode && (mappedStatus === 4 || mappedStatus === 5)) {
      if (isValid) {
        const updCompletionInfo =
          await workOrderSummaryRepositry.updateCompletionInfo(
            serviceType,
            completionInfoData?.id,
            API_Payload,
            categoryType
          );
        if (updCompletionInfo?.id) {
          dispatch({
            type: "CREATE_COMPLETIONINFO",
            payload: {
              ...completionInfoData,
              id: updCompletionInfo?.id,
              timeStamp: updCompletionInfo?.timestamp,
            },
          });
          setPage("Cost Info");
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        }
        else if (updCompletionInfo?.response?.data?.status === 400) {
          setErrorDialog(true);
          setErrorDialogMssg(`${updCompletionInfo?.response?.data?.detail}`)
        }
        else if (updCompletionInfo?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg(
            "An unexpected error occurred while processing your request."
          );
        }
      }
    } else if (viewmode == true || mappedStatus === 6 || mappedStatus === 7) {
      setPage("Cost Info");
      dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    }
    setLoading(false);
  };

  const handleCloseErrRequestDialog = () => {
    setErrorDialog(false);
    setErrorDialogMssg("");
  };

  const handleConfirmErrRequestDialog = (e) => {
    e.preventDefault();
    setErrorDialog(false);
    setErrorDialogMssg("");
  };

  const handleSignatureAddRow = () => {
    const id =
      signatureRows.length > 0
        ? Math.max(...signatureRows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
        : 1;
    const newRow = {
      id: id,
      category: '',
      fileType: '',
      designation: '',
      size: '',
    };
    setSignatureRows((oldRows) => [...oldRows, newRow]);
  };

  const fetchFormData = async () => {
    setLoading(true);
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${getAuthToken('id_token')}`,
        },
      };
      const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
      const completionCategoryFieldName = categoryType === "Scheduled" ? "Getscheduled" : "Getunscheduled";
      const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

      const response = await axios.get(`${checkGraph}/api/${checkFemorBem}unscheduledworkorder/${completionCategoryFieldName}signatureList/${basicDetails?.id},1,5000`, config);
      const rowsData = response.data.map((item) => ({
        id: item?.id,
        name: item?.documenttitle || '',
        designation: item?.designation || '',
        fileType: item?.documenttype || '',
        size: item?.filesize || '',
        date: item?.signaturedate || '',
        filename: item?.filename || '',
        rating: item?.rating || '',
        remarks: item?.remarks || '',
      }));

      if (response?.data?.length > 0) {
        setGetByIdSignatures(response?.data);
        setSignatureRows(rowsData);
      } else if (viewmode === true || mappedStatus === 6 || mappedStatus === 7) {
        setSignatureRows(rowsData || []);
      }
      else {
        const newRow = {
          id: 1,
          category: '',
          fileType: '',
          designation: '',
          size: '',
        };
        setSignatureRows([newRow]);
      }
    } catch (error) {
      if (viewmode === true || mappedStatus === 7) {
        setSignatureRows([]);
      }
      console.log(error);
    };
    setLoading(false);

  };

  useEffect(() => {
    fetchFormData();
  }, []);


  // useEffect(() => {
  //     const id = basicDetails?.id;
  //     if (id) {
  //         fetchFormData();
  //     }
  // }, [isSignatureAffected]);

  const handleSaveSignature = (id, data) => {

    // Update the row with the new signature
    const updatedRows = signatureRows.map((row) =>
      row.id === id ? { ...row, ...data, fileSignature: data.file } : row
    );

    setSignatureRows(updatedRows);
    fetchFormData();
    setSignatureMandatory(false);
    setsignatureDialog(false);
  };



  const handleSignatureDownload = async (file) => {
    try {

      if (file && (file instanceof Blob || file instanceof File)) {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name ? file.name : 'signature';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
      } else {
        const id = file;
        const config = {
          headers: {
            Authorization: `Bearer ${getAuthToken('id_token')}`,
          },
        }
        const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${id}`, {
          ...config,
          responseType: 'blob'
        });
        const url = URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = file?.name ? file.name : 'signature';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
      }

    } catch (error) {
      console.error('Error downloading file:', error);
    }

  };


  const handleSignatureUpload = (id) => {
    setSelectedRowId(id);
    setsignatureDialog(true);
  };

  const handleSignatureCloseDialog = () => {
    setsignatureDialog(false);
  };

  const handleSignatureDeleteClick = (id) => () => {
    if (typeof id === 'string') {
      setSignatureId(id);
      setSignatureDeleteDialog(true);
    } else if (typeof id === 'number') {
      if (signatureRows.length > 1 || signatureRows?.[0]?.fileType !== '') {
        const updatedRows = signatureRows.filter((row) => row?.id !== id);
        setSignatureRows(updatedRows);
      }
    }
  };

  const handleSignatureEditClick = (rowData) => () => {
    setFormData({
      id: rowData?.id || null,
      date: rowData?.date ? dayjs(rowData?.date).format('DD/MM/YYYY') : null
    });
    setSignatureEditDialog(true);
  };

  const handlesavesignaturedate = async (formData) => {

    let putmethod =
    {
      id: formData?.id || null,
      signaturedate: formData?.date ? dayjs(formData?.date, 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00') : null
    }

    const completionCategoryFieldName = categoryType === "Scheduled" ? "Updatsignaturedate" : "Updatsignaturedate";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const CategoryFieldName = categoryType === "Scheduled" ? "Scheduled" : "Unscheduled";
    const controller = serviceType === "fem" ? "Graphfemworkorder" : "Graphbemworkorder";
    const config = {
      headers: {
        Authorization: `Bearer ${getAuthToken('id_token')}`,
      },
    }
    const response = await axios.put(`${checkGraph}/api/${controller}/${completionCategoryFieldName}/${formData?.id}/${CategoryFieldName}`, putmethod, config);
    if (response) {

      setSignatureEditDialog(false);
      fetchFormData();
    }
  }

  const handleConfirmSignatureDeleteClick = async () => {
    const fetchedFiles = getByIdSignatures?.find((item) => item?.id === signatureId);
    if (getByIdSignatures.length > 0 && fetchedFiles) {
      try {
        const completionCategoryFieldName = categoryType === "Scheduled" ? "schcompletionsignatures" : "unschcompletionsignatures";
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const config = {
          headers: {
            Authorization: `Bearer ${getAuthToken('id_token')}`,
          },
        }
        const response = await axios.delete(`${checkGraph}/api/${serviceType}${completionCategoryFieldName}/${signatureId}`, config);
        if (response) {
          setIsSignatureAffected(true);
          fetchFormData();
        }
      } catch (error) {
        console.log("Error deleting item:", error);
      }
    } else {
      const updatedRows = signatureRows.filter((row) => row?.id !== signatureId);
      setSignatureRows(updatedRows);
    }
    setSignatureDeleteDialog(false);
  };

  const handleSignatureDeleteDialogClose = () => {
    setSignatureDeleteDialog(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    }

    try {
      let date;
      date = parseISO(dateString);

      if (!isValid(date)) {
        date = new Date(dateString);
      }

      if (!isValid(date)) {
        return 'Invalid Date';
      }

      const formattedDate = format(date, 'dd/MM/yyyy');
      return formattedDate;

    } catch (error) {
      console.error('Error parsing date:', error.message);
    }
  };

  const roleName = localStorage.getItem("roleName");

  const columns = [
    {
      field: 'signature',
      headerName: 'Signature',
      minWidth: 150,
      cellRenderer: (params) => (
        <Button
          variant="outlined"
          component="label"
          size="small"
          sx={{
            width: '100px',
            height: '38px',
            padding: '4px 8px',
            fontSize: '0.75rem',
            display: 'flex',
            justifyContent: 'center',
          }}
          onClick={() => handleSignatureUpload(params.data.id)}
          disabled={((params?.data?.file?.type || params?.data?.fileType) ? true : false) || mappedStatus === 6}
        >
          {(params?.data?.file?.type || params?.data?.fileType) ? 'Uploaded' : 'Upload'}
        </Button>
      ),
    },
    { field: 'name', headerName: 'Name', editable: false, wrapHeaderText: false, width: '100px' },
    { field: 'designation', headerName: 'Designation', editable: false, wrapHeaderText: false },
    { field: 'fileType', headerName: 'File Type', editable: false, wrapHeaderText: false },
    { field: 'size', headerName: 'Size', editable: false, wrapHeaderText: false },
    { field: 'date', headerName: 'Date', editable: false, wrapHeaderText: false, valueGetter: (params) => formatDate(params?.data?.date) },
    {
      field: 'rating', headerName: 'Rating', editable: false, wrapHeaderText: false,
      cellRenderer: (params) => (
        <>
          {params?.data?.rating ? (
            <Rating
              name="simple-controlled"
              value={params?.data?.rating}
              readOnly
            />
          ) : (
            ""
          )}
        </>
      )
    },
    { field: 'remarks', headerName: 'Remarks', editable: false, wrapHeaderText: false },
    {
      field: 'actions',
      headerName: 'Actions',
      //   width: 200,           // or try width: 100 for tighter fit
      minWidth: 300,
      maxWidth: 350,
      cellRenderer: (params) => (
        <>{params?.data?.filename && (roleName === "Helpdesk" || roleName == "FMSExec") && (
          <CustomTooltip title="Edit">
            <Button
              onClick={handleSignatureEditClick(params?.data)}
              disabled={
                viewmode ||
                mappedStatus === 6 ||
                (signatureRows?.length === 1 && params?.data?.id && !params?.data?.fileType)
              }
            >
              <EditIcon />
            </Button>
          </CustomTooltip>
        )}
          <CustomTooltip title="Delete">
            <Button onClick={handleSignatureDeleteClick(params?.data?.id)} disabled={viewmode || mappedStatus === 6 || ((signatureRows?.length === 1 && params?.data?.id && !params?.data?.fileType) ? true : false)}>
              <DeleteIcon />
            </Button>
          </CustomTooltip>
          {params?.data?.filename && (
            <CustomTooltip title="Download">
              <Button onClick={() => handleSignatureDownload(params?.data?.filename)} >
                <DownloadIcon />
              </Button>
            </CustomTooltip>
          )}

        </>
      ),
    }
  ];


  return (
    <>
      <PageLoader open={loading} />
      <ComponentHeader
        mainHeader={findHeaderContent?.mainHeader}
        subHeader={findHeaderContent?.subHeader}
        secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
        requiredButton={viewmode ? false : findHeaderContent?.requiredButton}
      />
      <Box>
        <form onSubmit={handleSubmit} noValidate>
          <Stack direction={"row"} alignItems={"center"} gap={1.5}>
            <Typography
              m={0}
              variant="title2"
              color={"text.primary"}
              fontWeight={600}
            >
              {basicDetails?.workOrderNo || ""}
            </Typography>
          </Stack>
          <Grid container spacing={2}>
            {/* {!setOutsourceDetails && <> */}
            <Grid item xs={12} md={4} sm={3}>
              <CustomTextField
                label={setScheduledField ? "Assignee" : "Responded By"}
                id="respondedBy"
                name="respondedBy"
                value={respondedBy || completionInfoData?.respondedBy || ""}
                // disabled={viewmode || mappedStatus === 6}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={3}>
              <CustomTextField
                label="Designation"
                id="designation"
                name="designation"
                value={designation || completionInfoData?.designation || ""}
                // disabled={viewmode || mappedStatus === 6}
                disabled={true}
              // readOnly={true}
              />
            </Grid>
            {/* </>} */}

            {!setScheduledField && (
              <>
                <Grid item xs={6} md={4} sm={6}>
                  <CustomDateTimePicker
                    label="Respond date and Time"
                    onDateChange={(e) =>
                      handleOnchange(e, "respondedDateandTime")
                    }
                    isMandatoryField={true}
                    value={getRespondStartDateandTime}
                    error={error?.respondedDateandTime}
                    helperText={errorMessage?.respondedDateandTime}
                    disableFutureDate={false}
                    disabled={true}
                    displayDefaultValue={false}
                  />
                </Grid>
                <Grid item xs={12} md={4} sm={2}>
                  <CustomTextField
                    label="Response Duration"
                    id="duration"
                    name="duration"
                    onChange={handleOnchange}
                    value={completionInfoData?.duration || 0}
                    disabled={true}
                  />
                  {/* <CustomTimePicker
                    label="Response Duration"
                    id="duration"
                    name="duration"
                    value={completionInfoData?.duration || 0}
                    onTimeChange={(e) => handleOnchange(e, "duration")}
                    modal={true}
                    disabled={true}
                  /> */}
                </Grid>
              </>
            )}
          </Grid>

          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: "0rem" }}>
            <Typography variant="title2"> Completion Details</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} sm={6}>
                <CustomTextFieldWithSearch
                  label="Completion By"
                  id="completionBy"
                  name="completionBy"
                  onChange={handleOnchange}
                  options={option?.respondedBy || []}
                  // value={setOutsourceDetails ? { id: basicDetails?.assessments?.vendor?.id || "", label: basicDetails?.assessments?.vendor?.label || "" } : completionInfoData?.completionBy || ""}
                  value={completionInfoData?.completionBy || ""}
                  error={error?.completionBy}
                  errorMessage={errorMessage?.completionBy}
                  isMandatoryField={!setOutsourceDetails}
                  disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || setOutsourceDetails}
                  // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                  autoFocus={!setOutsourceDetails}
                />
              </Grid>

              <Grid item xs={6} md={3} sm={3}>
                <CustomDateTimePicker
                  open={signatureEditDialog}
                  label="Start date and Time"
                  onDateChange={(e) => handleOnchange(e, "startDateandTime")}
                  value={getFirstIndexofStartDateTime || ""}
                  disableFutureDate={false}
                  disabled={true}
                  displayDefaultValue={false}
                />
              </Grid>
              <Grid item xs={6} md={3} sm={3}>
                <CustomDateTimePicker
                  label="End date and Time"
                  onDateChange={(e) => handleOnchange(e, "endDateandTime")}
                  value={getLastIndexofEndDateTime || ""}
                  disableFutureDate={false}
                  error={false}
                  disabled={true}
                  displayDefaultValue={false}
                />
              </Grid>
              <Grid item xs={6} md={3} sm={3}>
                <CustomTextField
                  label="Down Time Mins"
                  onDateChange={(e) => handleOnchange(e, "downTimeHours")}
                  value={completionInfoData?.downTimeHours || "0 Mins"}
                  disableFutureDate={true}
                  disabled={true}
                />
                {/* <CustomTimePicker
                  label="Down Time Hrs"
                  value={completionInfoData?.downTimeHours || downTimeHrs}
                  disableFutureDate={true}
                  disabled={true}
                  onTimeChange={(e) => handleOnchange(e, "downTimeHours")}
                  modal={true}
                /> */}
              </Grid>
            </Grid>
          </Box>

          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: "0rem" }}>
            <Typography variant="title2">Action Taken </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8} sm={8}>
                <CustomTextArea
                  label="Action Taken"
                  id="actiontaken"
                  onChange={(e) =>
                    handleOnchange(e, "actionTaken", "Action Taken")
                  }
                  value={completionInfoData?.actionTaken}
                  isMandatoryField={true}
                  error={error?.actionTaken}
                  helperText={errorMessage?.actionTaken}
                  disabled={
                    viewmode || mappedStatus === 6 || mappedStatus === 7
                  }
                  // disabled={viewmode || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                  maxlength={255}
                />
              </Grid>
            </Grid>
          </Box>

          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={2}>
              <Grid >
                <Typography variant="title2" align="left">Add Signature</Typography>
                <Typography variant="body2" >
                  {/* Please add files in format of doc, jpg, png, pdf. */}
                </Typography>
              </Grid>
              <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                {!viewmode && mappedStatus !== 6 && mappedStatus !== 7 && <AddRowButton onClick={handleSignatureAddRow} />}
              </Grid>
            </Stack>
            {signatureMandatory && (<Typography component={"span"} color={"error"}>
              {"Please add at least one Signature."}*
            </Typography>)}
            <CustomAgGrid
              rows={signatureRows}
              columns={columns}
              setGridApi={setGridApi}

            />

            <Dialog open={signatureDialog} onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                handleSignatureCloseDialog();
              }
            }} >
              <DialogContent>
                <SignatureGrid
                  onCancel={handleSignatureCloseDialog}
                  onClear={handleSignatureCloseDialog}
                  onSave={(data) => handleSaveSignature(selectedRowId, data)}
                  rowData={signatureRows.find((row) => row.id === selectedRowId)}
                />
              </DialogContent>
            </Dialog>

            <Dialog open={signatureEditDialog} onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                setsignatureDialog(false);
              }
            }}>
              <DialogTitle>Edit Signature Date</DialogTitle>
              <DialogContent>
                <CustomDatePicker
                  label="Signature Date"
                  id="date"
                  name="date"
                  value={formData?.date}
                  isMandatoryField={true}
                  onDateChange={(newDate) =>
                    setFormData(prev => ({ ...prev, date: newDate }))
                  }
                  modal={true}
                  maxDate={currentDate}
                  minimumDate={
                    basicDetails?.workorderDateandTime
                      ? dayjs(basicDetails?.workorderDateandTime).format('DD/MM/YYYY')
                      : ""
                  }
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setSignatureEditDialog(false)}>Cancel</Button>
                <Button onClick={() => {
                  handlesavesignaturedate(formData);
                }}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>

            <CustomDialog
              open={signatureDeleteDialog}
              onClose={handleSignatureDeleteDialogClose}
              title="Confirm Delete"
              content="Are you sure you want to delete?"
              confirmBtn="Yes"
              cancelBtn="No"
              onConfirm={handleConfirmSignatureDeleteClick}
              onCancel={handleSignatureDeleteDialogClose}
            />

          </Box>

          <Box>
            <BottomButtonsforWorkOrder
              page={page}
              buttonAttributes={buttonAttributes}
            />
          </Box>
        </form>
      </Box>



      <CustomAlert
        open={errorDialog}
        onClose={handleCloseErrRequestDialog}
        onConfirm={handleConfirmErrRequestDialog}
        content={errorDialogMssg}
        confirmBtn="OK"
        onWidth={true}
        onRemovePadding={true}
      />
    </>
  );
};

export default CompletionInfo;
